// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"cf114bc7","373":"83549456","381":"a0d05886"}[chunkId] + ".chunk.js";
};